import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import ConceptSection from '@/components/landing/concept-section'
import PlayToPitchSection from '@/components/landing/play-to-pitch-section'
import BusinessesSection from '@/components/landing/businesses-section'
import VisionSection from '@/components/landing/vision-section'
import StrategyBuilderSection from '@/components/landing/strategy-builder-section'
import ContactSection from '@/components/landing/contact-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <ConceptSection />
            <PlayToPitchSection />
            <BusinessesSection />
            <VisionSection />
            <StrategyBuilderSection />
            <ContactSection />
        </Layout>
    )
}

export default Home
